import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'motion/react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BookCover from '../components/BookCover';
import { Toaster } from 'sonner';

import { Highlighter } from '../components/ui/highlighter';

import { BACKEND_URL, API } from '../utils/api';
const R2_URL = process.env.REACT_APP_R2_URL || BACKEND_URL + "/api/static";

const FONT = {
  M: [[1, 0, 0, 0, 1], [1, 1, 0, 1, 1], [1, 0, 1, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1]],
  U: [[1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [0, 1, 1, 1, 0]],
  S: [[0, 1, 1, 1, 0], [1, 0, 0, 0, 1], [1, 0, 0, 0, 0], [0, 1, 1, 1, 0], [0, 0, 0, 0, 1], [1, 0, 0, 0, 1], [0, 1, 1, 1, 0]],
  E: [[1, 1, 1, 1, 1], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 1, 1, 1, 0], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 1, 1, 1, 1]],
  O: [[0, 1, 1, 1, 0], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [0, 1, 1, 1, 0]],
  D: [[1, 1, 1, 0, 0], [1, 0, 0, 1, 0], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 1, 0], [1, 1, 1, 0, 0]],
  L: [[1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 1, 1, 1, 1]],
  A: [[0, 1, 1, 1, 0], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 1, 1, 1, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1]],
  F: [[1, 1, 1, 1, 1], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 1, 1, 1, 0], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0], [1, 0, 0, 0, 0]],
  m: [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [1, 0, 1, 0, 1], [1, 1, 0, 1, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1]],
  u: [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 1, 1], [0, 1, 1, 0, 1]],
  s: [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 1, 1, 1, 0], [1, 0, 0, 0, 0], [0, 1, 1, 1, 0], [0, 0, 0, 0, 1], [1, 1, 1, 1, 0]],
  e: [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 1, 1, 1, 0], [1, 0, 0, 0, 1], [1, 1, 1, 1, 1], [1, 0, 0, 0, 0], [0, 1, 1, 1, 0]],
  o: [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 1, 1, 1, 0], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [1, 0, 0, 0, 1], [0, 1, 1, 1, 0]],
  d: [[0, 0, 0, 0, 1], [0, 0, 0, 0, 1], [0, 1, 1, 0, 1], [1, 0, 0, 1, 1], [1, 0, 0, 0, 1], [1, 0, 0, 1, 1], [0, 1, 1, 0, 1]],
  l: [[1, 0, 0], [1, 0, 0], [1, 0, 0], [1, 0, 0], [1, 0, 0], [1, 0, 0], [0, 1, 0]],
  a: [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 1, 1, 1, 0], [0, 0, 0, 0, 1], [0, 1, 1, 1, 1], [1, 0, 0, 0, 1], [0, 1, 1, 1, 1]],
  f: [[0, 0, 1, 1], [0, 1, 0, 0], [1, 1, 1, 0], [0, 1, 0, 0], [0, 1, 0, 0], [0, 1, 0, 0], [0, 1, 0, 0]],
  ' ': [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]]
};

function buildGrid(text) {
  const rows = 7;
  const grid = Array.from({ length: rows }, () => []);
  text.split('').forEach((char, ci) => {
    const letter = FONT[char];
    if (!letter) return;
    if (ci > 0 && char !== ' ' && text[ci - 1] !== ' ') {
      for (let r = 0; r < rows; r++) grid[r].push(0);
    }
    for (let r = 0; r < rows; r++) {
      letter[r].forEach((v) => grid[r].push(v));
    }
  });
  return grid;
}

// Generate random starting positions for each pixel
function randomOrigin() {
  const side = Math.floor(Math.random() * 4);
  switch (side) {
    case 0:return { x: Math.random() * 800 - 400, y: -300 - Math.random() * 400 };
    case 1:return { x: 300 + Math.random() * 400, y: Math.random() * 600 - 300 };
    case 2:return { x: Math.random() * 800 - 400, y: 300 + Math.random() * 400 };
    default:return { x: -300 - Math.random() * 400, y: Math.random() * 600 - 300 };
  }
}

const TOTAL_TEXT = 'museo de la fe';

const AboutPage = () => {
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [phase, setPhase] = useState('flying'); // 'flying' | 'formed' | 'slid' | 'content'

  useEffect(() => {
    fetch(`${API}/books`).then((r) => r.json()).then((apiBooks) => {
      if (apiBooks?.length) {
        setBooks(apiBooks.map((b) => ({
          ...b, id: b.book_id || b.slug,
          coverUrl: `${R2_URL}/books/${b.imageFolder}/cover.webp`
        })));
      }
    }).catch(() => {});
  }, []);

  // Build grid and pixel data
  const grid = useMemo(() => buildGrid(TOTAL_TEXT), []);
  const cols = grid[0]?.length || 0;

  const pixels = useMemo(() => {
    const result = [];
    let bookIdx = 0;
    grid.forEach((row, r) => {
      row.forEach((filled, c) => {
        if (filled) {
          const book = books.length > 0 ? books[bookIdx % books.length] : null;
          bookIdx++;
          result.push({ r, c, book, origin: randomOrigin(), index: result.length });
        }
      });
    });
    return result;
  }, [grid, books]);

  // Animation sequence
  useEffect(() => {
    const t1 = setTimeout(() => setPhase('formed'), 2200);
    const t2 = setTimeout(() => setPhase('slid'), 3200);
    const t3 = setTimeout(() => setPhase('content'), 3800);
    return () => {clearTimeout(t1);clearTimeout(t2);clearTimeout(t3);};
  }, []);

  const sections = [
  { title: 'Libritos Cristianos Ilustrados para Niños', body: 'En Museo de la Fe creamos libritos bíblicos ilustrados para los más pequeños de la casa. Historias de fe contadas con amor, imágenes hermosas y palabras sencillas que los niños de 3 a 10 años pueden entender y disfrutar. Cada librito es una experiencia interactiva en formato flipbook digital.' },
  { title: '¿Por qué lo creamos?', body: 'Las historias de la Biblia son extraordinarias, pero muchas veces se presentan de formas que no conectan con los niños. Queríamos crear un espacio donde cada historia cobrara vida con ilustraciones hermosas y un lenguaje sencillo que los pequeños pudieran entender y disfrutar. Un lugar donde la fe se transmite con alegría, no con obligación.' },
  { title: '¿Para quién son nuestros libritos de fe?', body: 'Ideales para padres que quieren criar a sus hijos en la fe, maestros de escuela dominical, pastores, abuelos y ministerios infantiles. Nuestros libros infantiles bíblicos ilustrados están disponibles en formato digital para toda Latinoamérica y Estados Unidos hispano, sin costos de envío.' },
  { title: '¿Qué encontrarás aquí?', body: '1. Historias bíblicas contadas con amor y sencillez para niños\n2. Ilustraciones originales y coloridas que capturan la imaginación\n3. Formato flipbook interactivo para leer directamente en la web\n4. Precios accesibles para que toda familia pueda disfrutarlos' },
  ];

  return (
    <div className="min-h-dvh bg-background font-sans overflow-hidden">
      <Toaster position="top-center" />
      <Helmet>
        <title>About — Libritos Cristianos para Niños | Museo de la Fe</title>
        <meta name="description" content="Conoce Museo de la Fe. Libritos cristianos ilustrados para niños de 3 a 10 años basados en historias bíblicas." />
        <link rel="canonical" href="https://museodelafe.com/faq" />
      </Helmet>
      <Header />

      {/* Mosaic: centered then slides up */}
      <motion.div
        className="flex items-center justify-center"
        initial={{ height: '65vh', paddingTop: '2rem' }}
        animate={
        phase === 'flying' || phase === 'formed' ?
        { height: '65vh', y: 0, paddingTop: '2rem' } :
        { height: 'auto', y: 0, paddingTop: '2rem' }
        }
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}>

        <motion.div
          className="w-full max-w-2xl mx-auto px-6"
          animate={
          phase === 'slid' || phase === 'content' ?
          { y: 0, scale: 1 } :
          { y: 0, scale: 1 }
          }>

          <div
            className="grid gap-px select-none w-full relative"
            style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>

            {grid.flatMap((row, r) =>
            row.map((filled, c) => {
              if (!filled) return <div key={`${r}-${c}`} className="aspect-square" />;

              const px = pixels.find((p) => p.r === r && p.c === c);
              if (!px || !px.book) return <div key={`${r}-${c}`} className="aspect-square" />;

              const delay = px.index * 0.012;

              return (
                <div key={`${r}-${c}`} className="aspect-square">
                    <motion.div
                    className="w-full h-full"
                    initial={{
                      x: px.origin.x,
                      y: px.origin.y,
                      scale: 0,
                      rotate: Math.random() * 360 - 180,
                      opacity: 0
                    }}
                    animate={{
                      x: 0,
                      y: 0,
                      scale: 1,
                      rotate: 0,
                      opacity: 1
                    }}
                    transition={{
                      duration: 1.2,
                      delay: delay,
                      ease: [0.22, 1, 0.36, 1]
                    }}>

                      <a
                      href={`/libro/${px.book.slug}`}
                      className="block w-full h-full rounded-[22%] overflow-hidden transition-transform duration-200 ease-out hover:scale-110">

                        <BookCover book={px.book} hideTitle className="!rounded-[22%] !shadow-none" />
                      </a>
                    </motion.div>
                  </div>);

            })
            )}
          </div>
        </motion.div>
      </motion.div>

      {/* Content sections - appear after mosaic slides up */}
      <div className="max-w-xl mx-auto px-6 pt-10 pb-24">
        <div className="space-y-0">
          {sections.map((section, i) =>
          <motion.section
            key={i}
            className={`${i === 0 ? 'pb-8' : i === sections.length - 1 ? 'pt-8' : 'py-8'} ${i < sections.length - 1 ? 'border-b border-border' : ''}`}
            initial={{ opacity: 0, y: 30, filter: 'blur(6px)' }}
            animate={
            phase === 'content' ?
            { opacity: 1, y: 0, filter: 'blur(0px)' } :
            { opacity: 0, y: 30, filter: 'blur(6px)' }
            }
            transition={{
              duration: 0.6,
              delay: i * 0.15,
              ease: [0.22, 1, 0.36, 1]
            }}>

              <h2 className="text-sm text-muted-foreground/60 mb-4">{section.title}</h2>
              {section.body.includes('\n') ?
            <div className="space-y-2.5 text-[15px] text-foreground/80">
                  {section.body.split('\n').map((line, j) =>
              <p key={j}>{line}</p>
              )}
                </div> :

            <p className="text-[15px] leading-relaxed text-foreground/80">{section.body}</p>
            }
            </motion.section>
          )}
        </div>

        {/* FAQ CTA */}
        <motion.div
          className="mt-10 pt-8 border-t border-border"
          initial={{ opacity: 0 }}
          animate={phase === 'content' ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.5, delay: sections.length * 0.15 + 0.3 }}
        >
          <p className="text-[15px] leading-relaxed text-foreground/80">
            Si quieres saber más sobre nuestros libritos, visita nuestra sección de{' '}
            <span onClick={() => { navigate('/preguntas-frecuentes'); window.scrollTo(0, 0); }} className="cursor-pointer inline">
              <Highlighter action="underline" color="#FF9800" strokeWidth={2} animationDuration={800} isView>
                Preguntas Frecuentes
              </Highlighter>
            </span>
          </p>
        </motion.div>

        {/* Contact */}
        <motion.div
          className="mt-10 pt-8 border-t border-border"
          initial={{ opacity: 0 }}
          animate={phase === 'content' ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.5, delay: sections.length * 0.15 + 0.5 }}
        >
          <h2 className="text-sm text-muted-foreground/60 mb-3">Contacto</h2>
          <a href="mailto:admin@museodelafe.com" className="text-[15px] text-foreground/80 hover:text-foreground transition-colors">admin@museodelafe.com</a>
        </motion.div>
      </div>

      <Footer />
    </div>);

};

export default AboutPage;